import React, { useState, useEffect, useContext } from 'react';
import { Form, Spinner, Alert } from 'react-bootstrap';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../../assets/css/donor/auth/DonorAuth.css';
import AppContext from "../../../context/AppContext";

const DonorLogin = () => {

  const navigate = useNavigate();

  const { baseUrl, regExpChecker } = useContext(AppContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  useEffect(() => {
    const donorEmail = localStorage.getItem('donorEmail');
    const donorPassword = localStorage.getItem('donorPassword');

    if (donorEmail && donorPassword) {
      donorAutoLogin(donorEmail, donorPassword);
    }
  }, []);

  const donorAutoLogin = (donorEmail, donorPassword) => {

    setIsLoading(true);

    const formdata = new FormData();
    formdata.append('email', donorEmail);
    formdata.append('password', donorPassword);

    axios.post(`${baseUrl}/donor/auth/donorlogin`, formdata)

      .then((response) => {

        if (response.data.error) {
          setError(response.data.error);
        } else if (response.data.donor) {
          navigate('/donor/dashboard');
        } else {
          setError('Invalid email or password');
        }

        setIsLoading(false);
      })

      .catch((error) => {
        setError(error.response?.data?.message || 'Something went wrong!');
        setIsLoading(false);
      });
  };

  const handleLogin = () => {

    setIsLoading(true);

    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('password', password);

    axios.post(`${baseUrl}/donor/auth/donorlogin`, formdata)

      .then((response) => {

        if (response.data.error) {
          setError(response.data.error);
        } else if (response.data.donor) {

          localStorage.setItem('donorEmail', email);
          localStorage.setItem('donorPassword', password);

          navigate('/donor/dashboard');

        } else {
          setError('Invalid email or password');
        }

        setIsLoading(false);
      })

      .catch((error) => {
        setError(error.response?.data?.message || 'Something went wrong!');
        setIsLoading(false);
      });
  };

  return (
    <div className="donor-auth-container">
      <div className="donor-auth-card">
        <div className="row g-0">

          {/* LEFT SIDE */}
          <div className="col-md-6 donor-auth-left">
  <div className="donor-auth-branding">

    {/* Animated Circles */}
    <div className="donor-auth-bg-animation">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <h1 className="donor-auth-brand-title">
      Welcome Back Donor.
    </h1>

    <p className="donor-auth-brand-subtitle">
      Your donations are changing lives every day 💙
    </p>

    {/* Animated Stats */}
    <div className="donor-auth-stats">
      <div className="donor-auth-stat">
        <h3>500+</h3>
        <p>Students Helped</p>
      </div>
      <div className="donor-auth-stat">
        <h3>1.2M</h3>
        <p>Donations</p>
      </div>
      <div className="donor-auth-stat">
        <h3>300+</h3>
        <p>Donors</p>
      </div>
    </div>

  </div>
</div>

          {/* RIGHT SIDE */}
          <div className="col-md-6 donor-auth-right">
            <div className="donor-auth-form-wrapper">

              <h2 className="donor-auth-form-title">Sign In</h2>
              <p className="donor-auth-form-subtitle">
                Enter your credentials to access donor dashboard
              </p>

              {error && <Alert variant="danger" className="donor-auth-alert">{error}</Alert>}

              <Form>

                {/* EMAIL */}
                <Form.Group className="donor-auth-form-group">
                  <Form.Label className="donor-auth-label">Email</Form.Label>

                  <div className="donor-auth-input-wrapper">
                    <span className="donor-auth-input-icon">
                      <Mail size={18} />
                    </span>

                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      className="donor-auth-input"
                      value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                     setEmailError(regExpChecker("email", event.target.value));
                  }
                  }
                    />
                      <p style={{ color: "red" }}>{emailError}</p>
                  </div>
                </Form.Group>

                {/* PASSWORD */}
                <Form.Group className="donor-auth-form-group">
                  <Form.Label className="donor-auth-label">Password</Form.Label>

                  <div className="donor-auth-input-wrapper">
                    <span className="donor-auth-input-icon">
                      <Lock size={18} />
                    </span>

                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Enter password"
                      className="donor-auth-input"
                    value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setPasswordError(regExpChecker("password", event.target.value));
                  }
                  }
                    />
                     <p style={{ color: "red" }}>{passwordError}</p>

                    <button
                      type="button"
                      className="donor-auth-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </Form.Group>

                {/* BUTTON */}
                <button
                  type="button"
                  className="donor-auth-submit-btn"
                  disabled={isLoading}
                  onClick={handleLogin}
                >
                  {isLoading ? <Spinner size="sm" /> : "Sign In"}
                </button>

                {/* FOOTER */}
                <div className="donor-auth-footer">
                  <p>
                    Don't have an account?{" "}
                    <Link to="/donor/register" className="donor-auth-link">
                      Sign Up
                    </Link>
                  </p>
                </div>

              </Form>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DonorLogin;